import React from "react";

export const BrexCategorised = ({ size = "24" }: { size?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect x="2" y="2" width="20" height="20" rx="10" fill="white" />
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="10"
        fill="url(#paint0_linear_2105_1311)"
      />
      <mask
        id="mask0_2105_1311"
        maskUnits="userSpaceOnUse"
        x="5"
        y="7"
        width="14"
        height="10"
      >
        <path d="M18.6663 7H5.33301V17H18.6663V7Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2105_1311)">
        <path
          d="M14.0697 7.8C13.571 8.45 13.4505 8.66657 12.9691 8.66657H5.78125V17H8.60144C9.23766 17 9.85657 16.7 10.2521 16.2C10.7681 15.5334 10.8367 15.3334 11.3354 15.3334H18.5406V7H15.703C15.0668 7 14.4482 7.3 14.0697 7.8ZM16.305 13.1835H13.2957C12.6421 13.1835 12.0406 13.45 11.645 13.9666C11.129 14.6335 11.0258 14.8335 10.5444 14.8335H7.99952V10.8334H11.0088C11.662 10.8334 12.2639 10.5334 12.6594 10.0334C13.1754 9.38344 13.313 9.18344 13.7771 9.18344H16.305V13.1835Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2105_1311"
          x1="12.0517"
          y1="2"
          x2="22.8268"
          y2="8.62105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B29BFF" />
          <stop offset="1" stopColor="#8064DE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
